import styles from './index.module.scss';
const fadeIn = ( props: { children: any }) => {
    return <div className={styles.fadeIn}>{props.children}</div>
}

export default fadeIn;